// extracted by mini-css-extract-plugin
export var button = "button-module--button--25e5a";
export var primary = "button-module--primary--93d62";
export var secondary = "button-module--secondary--7205d";